import './App.css';
import Layout from './layout';

function App() {
  return (
    <div className="App">
      <Layout/>
    </div>
  );
}

export default App;
